import axios from "axios";
import { useSelector } from "react-redux";

import { IsEmptyOrNullOrUndefined } from "@helpers/Utils";
import { useQuery } from "@tanstack/react-query";

const ARCHEM_URL = process.env.REACT_APP_API_URL + "archemsystem/";

export const keysArchemicalsMainApp = {
  all: [{ scope: 'archemicals.main.app' }],
  getNewTransactionUuid: () => [{ ...keysArchemicalsMainApp.all[0] }],
  getAppVersions: () => [{ ...keysArchemicalsMainApp.all[0], entity: 'app.versions' }],
  getUserPermissions: (user_name) => [{ ...keysArchemicalsMainApp.all[0], entity: 'archem.user.permissions', user_name }],
}

export const useGetUserPermissions = (isGetUserPermissions) => {
  const { currentUser } = useSelector((state) => ({ currentUser: state?.auth?.user?.user }));

  const getData = async ({ queryKey: [{ user_name }] }) => {
    const { data } = await axios.get(`${ARCHEM_URL}settings/GetUserPermissions`, { params: { user_name } })
    return data;
  }

  return useQuery(keysArchemicalsMainApp.getUserPermissions(currentUser?.username), getData, {
    enabled: !IsEmptyOrNullOrUndefined(currentUser?.username) && isGetUserPermissions
  })
}

export const useArchemMainGetNewUuid = () => {

  const getData = async () => {
    const { data } = await axios.get(`${ARCHEM_URL}settings/GetNewUuid`)
    return data;
  }

  return useQuery(keysArchemicalsMainApp.getNewTransactionUuid(), getData)
}

export const useArchemSystemAppVersions = () => {
  const getData = async () => {
    const { data } = await axios.get(`${ARCHEM_URL}settings/GetAppVersions`)
    return data;
  }

  return useQuery(keysArchemicalsMainApp.getAppVersions(), getData)
}